module.exports = __webpack_public_path__ + "static/media/photo34.2e15a724.jpg";